import React, { useEffect, useState } from 'react'
import QRCode from 'react-qr-code'
import moment from 'moment'

import {
  Clear as ClearIcon,
  ContentCopyOutlined as ContentCopyOutlinedIcon,
} from '@mui/icons-material'
import { localizedStrings } from '@core/strings'
import { Palette } from '@core/theme/color-palette-siteassist'

import { ModalDialogContainer } from '@common/modal'
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
} from '@common/material'
import { useModal } from '@common/GlobalModal'
import { Checklist } from '@core/entities/checklist/Checklist'
import { Box, Text } from '@fundamentals'
import { copyTextToClipboard } from '@core/utils/copy-to-clipboard'
import { useToast } from '@core/toast'

type BriefingQRShareModalProps = {
  checklist: Checklist
}

export const BriefingQRShareModal: React.FC<BriefingQRShareModalProps> = ({
  checklist,
}) => {
  const { hideModal } = useModal()

  const toast = useToast()
  const qrCodeUrl = checklist.getBriefingIntentUrl(Project.appUrl)

  const [innerHeight, setInnerHeight] = useState(window.innerHeight)
  const maxQrCodeSize = innerHeight * 0.35

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <ModalDialogContainer>
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20, mb: 0 }}
      >
        {localizedStrings.scanToJoin}
        <IconButton aria-label='close-modal' onClick={hideModal}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Text mt={2} mb={2}>
          {localizedStrings.scanToJoinDescription}
        </Text>
        <Box
          display='flex'
          flexDirection='column'
          mt={3}
          justifyContent='center'
          alignItems='center'
        >
          <QRCode
            value={qrCodeUrl}
            style={{
              maxHeight: maxQrCodeSize,
              maxWidth: maxQrCodeSize,
            }}
          />

          {!!checklist?.selfAccess?.validUntil && (
            <Text mt={1} fontSize={13} color={Palette.Grey[500]}>
              {`${localizedStrings.validUntil}: ${moment(
                checklist.selfAccess.validUntil,
              ).format('DD MMM YYYY HH:mm')}`}
            </Text>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ pt: 1, pb: 2, pl: 3, pr: 3 }}>
        <Button
          sx={{ width: 200 }}
          variant={'outlined'}
          startIcon={<ContentCopyOutlinedIcon />}
          onClick={() => {
            copyTextToClipboard(qrCodeUrl)
            toast.success(localizedStrings.copiedToClipBoard)
          }}
        >
          {localizedStrings.copyToClipboard}
        </Button>

        <Button variant='contained' color='primary' onClick={hideModal}>
          {localizedStrings.close}
        </Button>
      </DialogActions>
    </ModalDialogContainer>
  )
}
